import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';
import { persist } from 'zustand/middleware';

interface AppState {
  darkMode: boolean;
  drawerCollapsed: boolean;
  rightPanelTab: 'world' | 'characters' | 'npc' | 'outline' | 'conflict' | 'hooks' | 'mood' | 'risk' | 'audience';
}

interface AppActions {
  toggleDark: () => void;
  toggleDrawer: () => void;
  setAtlasTab: (t: AppState['rightPanelTab']) => void;
}

export const useAppStore = create<AppState & AppActions>()(
  persist(
    immer((set) => ({
      darkMode: false,
      drawerCollapsed: false,
      rightPanelTab: 'outline',
      toggleDark: () =>
        set((s) => {
          s.darkMode = !s.darkMode;
          if (s.darkMode) document.documentElement.classList.add('dark');
          else document.documentElement.classList.remove('dark');
        }),
      toggleDrawer: () =>
        set((s) => {
          s.drawerCollapsed = !s.drawerCollapsed;
        }),
      setAtlasTab: (t) =>
        set((s) => {
          s.rightPanelTab = t;
        }),
    })),
    {
      name: 'starfox-app',
      partialize: (s) => ({
        darkMode: s.darkMode,
        drawerCollapsed: s.drawerCollapsed,
        rightPanelTab: s.rightPanelTab,
      }),
    },
  ),
);
